<template>
<div id="pageDashboard">
    <v-card>
        <v-card-title>Quote</v-card-title>
        <v-layout wrap>
            <v-flex>
                <div style="display: flex">
                    <div class="dropbox">
                        <v-btn color="blue-grey" class="white--text" @click="loader = 'isSaving'" :disabled="isHiddenUploadFile">
                            Select File Upload
                            <v-icon right dark>cloud_upload</v-icon>
                        </v-btn>

                        <input id="files" ref="files" type="file" :name="uploadFieldName" v-on:change="handleFilesUpload()" accept=".pdf" class="input-file" :disabled="isHiddenUploadFile" />
                    </div>
                    <div v-if="files" class="show_file">
                        <span class="name-file">{{ files.name }}</span>
                        <v-icon style="margin-bottom: -2px" right color="red" v-on:click="removeFile()">remove_circle</v-icon>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-card>
</div>
</template>

<script>
import QuoteService from "../services/quote.service.js";
export default {
    inject: ["$validator"],
    metaInfo() {
        return {
            title: "Dashboard cibes"
        };
    },
    data: () => ({
        isHiddenUploadFile: false,
        loading: false,
        uploadFieldName: "uploadFiles",
        files: {},
        quoteService: new QuoteService(),
    }),
    created() {
        this.getData();
    },
    computed: {},
    mounted() {},
    methods: {
        getData() {
            this.quoteService.getListQuote().then(res => {
                this.files = res;
                if (this.files) {
                    this.isHiddenUploadFile = true;
                } else {
                    this.isHiddenUploadFile = false;
                }
            });
        },
        handleFilesUpload() {
            this.files = this.$refs.files.files[0];
            this.quoteService.addFileQuote(this.files).then(() => {
                this.getData();
            })
        },
        removeFile() {
            this.quoteService.deleteQuote(this.files.id).then(() => {
                this.getData();
            });
        }
    }
}
</script>

<style>
li {
    text-decoration: none;
    list-style-type: none;
}

.list-poo img {
    max-width: 200px;
}

.dropbox {
    /*outline: 2px dashed grey; !* the dash box *!*/
    outline-offset: -10px;
    /*background: lightcyan;*/
    color: dimgray;
    padding: 10px 10px;
    /*min-height: 200px; !* minimum height *!*/
    position: relative;
    cursor: pointer;
}

.show_file {
    display: flex;
    align-items: center;
    justify-content: center;
}

.input-file {
    opacity: 0;
    /* invisible but it's there! */
    width: 100%;
    height: 50px;
    position: absolute;
    left: 10px;
    margin-top: 10px;
    top: 0;
    cursor: pointer;
}

.dropbox:hover {
    /*background: lightblue; !* when mouse over to the drop zone, change color *!*/
}

.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}

.v-toolbar__content {
    /* height: 100% !important; */
}

/* @media screen and (max-width: 600px) {
     .inp-search {
        order: -1;
        flex: 1 0 100%;
    }
} */
table.v-table tbody td a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.87);
}

.title-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}

.inp-search {
    max-width: 440px;
    width: 100%;
}

.group-control {
    text-align: center;
}

#pageDashboard .v-datatable__actions {
    position: relative;
}

@media screen and (min-width: 1080px) {
    .actions-list {
        left: calc(50% - 55px);
    }
}

.actions-list {
    position: absolute;
    top: 5px;
}

.v-card__title {
    font-size: 18px;
    font-weight: bold;
    background-color: #f5f5f5;
}

.v-card__actions {
    padding: 15px 10px;
}

.top-content {
    background-color: #f5f5f5;
    color: rgba(0, 0, 0, 0.87);
}

table.v-table tbody td {
    word-break: break-word;
}

.list-po tbody tr td:nth-child(1) {
    min-width: 150px;
}

.file-listing {
    display: flex;
}

.name-file {
    max-width: 260px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
